<div class="layout-wrapper" style="background-color: rgb(242, 245, 253); height: 100vh;">
    <app-topbar-login></app-topbar-login>
    <div class="layout-main">
        <div class="layout-content" style="background-color: rgb(242, 245, 253);">
            <router-outlet></router-outlet>
        </div>
        <app-footer-login></app-footer-login>
    </div>
    <div class="layout-mask" *ngIf="mobileMenuActive"></div>
</div>
